"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._deserialize = void 0;
const yup = require("yup");
const yupReducer = (yupSchema, propertyOrArgument, i) => {
    if (i % 2)
        return handleSchemaArgument(yupSchema, propertyOrArgument);
    return handleSchemaProperty(yupSchema, propertyOrArgument);
};
const convertObject = (obj) => Object.fromEntries(Object.entries(obj).map(([key, value]) => [
    key,
    Array.isArray(value) ? value.reduce(yupReducer, yup) : value,
]));
const transformArgument = (argument) => {
    if ((argument === null || argument === void 0 ? void 0 : argument.objType) === "regexp") {
        return new RegExp(argument.value, argument.flags);
    }
    return argument;
};
const handleSchemaArgument = (yupChain, argument) => {
    if (argument === null || argument === undefined)
        return yupChain();
    if (typeof argument === "object" && !Array.isArray(argument))
        return yupChain(convertObject(argument));
    if (Array.isArray(argument))
        return yupChain(...argument.map((arg) => transformArgument(arg)));
    return yupChain(transformArgument(argument));
};
const handleSchemaProperty = (yupChain, property) => {
    const result = yupChain[property];
    if (typeof result === "function")
        return result.bind(yupChain);
    return result;
};
const _deserialize = (serializedSchema) => {
    if (!serializedSchema.root)
        throw new TypeError("serializedSchema has no root");
    if (!Array.isArray(serializedSchema.root))
        throw new TypeError("The root of a schema should always be an array");
    const { root } = serializedSchema;
    return root.reduce(yupReducer, yup);
};
exports._deserialize = _deserialize;
